/* istanbul ignore file */

export enum MapPinColor {
    Red = 1,
    Orange = 2,
    Yellow = 3,
    Green = 4,
    Aqua = 5,
    Blue = 6,
    Purple = 7,
    Gray = 8,
    AppColor = 9,
}

export enum MapPinColorName {
    Red = "red",
    Orange = "orange",
    Yellow = "yellow",
    Green = "green",
    Aqua = "aqua",
    Blue = "blue",
    Purple = "purple",
    Gray = "gray",
    AppColor = "default color",
}
